import React from 'react'
import { StyleSheet, View } from 'react-native'
import { Card, Text, Chip } from 'react-native-paper'
import { useTheme } from '../../../../hooks/theme.hook'
import { useNavigation } from '@react-navigation/native'
import { AppNavigation } from '../../../../navigation/types'
import { NodeTopPerspectivesQuery } from '../../../../generated/graphql'

interface PerspectiveStatsTableProps {
  perspective: NodeTopPerspectivesQuery['nodeTopPerspectives']['perspectives'][0]
  rank: number
}

export function PerspectiveStatRow({
  perspective,
  rank,
}: PerspectiveStatsTableProps) {
  const theme = useTheme()
  const navigation = useNavigation<AppNavigation>()

  const handlePress = () => {
    navigation.navigate('Perspective', { articleId: perspective.id })
  }

  const handleClusterPress = () => {
    if (perspective.cluster) {
      navigation.navigate('ClusterCards', { clusterId: perspective.cluster.id })
    }
  }

  return (
    <Card style={styles.card} onPress={handlePress}>
      <Card.Content style={styles.content}>
        <View style={styles.rankSection}>
          <Text variant="labelLarge" style={styles.rankText}>
            #{rank}
          </Text>
        </View>
        <View style={styles.mainSection}>
          <Text variant="titleMedium" style={styles.title} numberOfLines={2}>
            {perspective.title}
          </Text>

          {perspective.cluster && (
            <Chip
              style={styles.clusterChip}
              textStyle={styles.clusterText}
              onPress={handleClusterPress}
              compact
            >
              {perspective.cluster.topic}
            </Chip>
          )}
          <Text variant="bodySmall" style={styles.date}>
            {new Date(perspective.createdAt).toISOString().split('T')[0]}
          </Text>
        </View>
        <View style={styles.voteSection}>
          <Text variant="bodySmall" style={styles.label}>
            Votes
          </Text>
          <Text variant="titleLarge">{perspective.voteCount}</Text>
        </View>
      </Card.Content>
    </Card>
  )
}

const styles = StyleSheet.create({
  card: {
    marginBottom: 8,
  },
  content: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
  },
  rankSection: {
    marginRight: 12,
    minWidth: 40,
    alignItems: 'center',
  },
  rankText: {
    fontWeight: '600',
    textAlign: 'center',
  },
  mainSection: {
    flex: 1,
    marginRight: 16,
    gap: 8,
  },
  title: {
    fontWeight: '500',
  },
  date: {
    opacity: 0.6,
    marginTop: 4,
  },
  clusterChip: {
    alignSelf: 'flex-start',
  },
  clusterText: {
    fontSize: 11,
  },
  voteSection: {
    alignItems: 'center',
    minWidth: 60,
  },
  label: {
    opacity: 0.6,
    marginBottom: 4,
  },
})
